export const subChildParentStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap:"1rem",
}